import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import WastageAfterIssueChart from "./WastageAfterIssueChart";

// Static data for wastage after issue (returned units per hospital)
const STATIC_WASTAGE_DATA = {
  hospitals: ["Hospital 1", "Hospital 2", "Hospital 3", "Hospital 4"],
  unitsReturned: [35, 22, 18, 28],
};

const WastageAfterIssueWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={6} lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Wastage After Issue (Returned Units per Hospital)")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <WastageAfterIssueChart data={STATIC_WASTAGE_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default WastageAfterIssueWrapper;
